import React from 'react';
import { string } from 'prop-types';
import { Helmet } from 'react-helmet';

const HeadHelmet = ({
  metaRobots,
  cannonicalUrl,
  metaDescription,
  metaKeywords,
  title,
  alternateUrl,
}) => {
  return (
    <Helmet>
      {cannonicalUrl && <link rel="canonical" href={cannonicalUrl} />}
      {alternateUrl && <link rel="alternate" href={alternateUrl}></link>}
      {metaRobots && <meta name="robots" content={metaRobots} />}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      {title && <title>{title}</title>}
    </Helmet>
  );
};

HeadHelmet.propTypes = {
  metaRobots: string,
  cannonicalUrl: string,
  alternateUrl: string,
  metaDescription: string,
  metaKeywords: string,
  title: string,
};

export { HeadHelmet };
